import { withJsonFormsControlProps } from "@jsonforms/react";
import { Box, CircularProgress, Stack } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";
import ModalMidiaFile from "components/CRPComponents/Forms/components/ModalMediaFileSelect";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { Fragment, useCallback } from "react";
import { useState } from "react";
import useMediaGallery from "./hooks/useMediaGallery";
import { CustomRendererProps } from "../types";

const GalleryMediaFileId = ({
  data: id,
  handleChange,
  path,
  label,
  required,
  errors,
  description,
  enabled,
}: CustomRendererProps<number>) => {
  const [open, setOpen] = useState(false);
  const [hasError, setError] = useState(false);
  const { setUrl, url, loading } = useMediaGallery(id);

  const onSelectImage = ({ id: newId, url: newUrl }: { id: number; url: string }) => {
    setOpen(false);
    setUrl(newUrl);
    handleChange(path, newId);
    setError(false);
  };

  const handleOpen = useCallback(() => setOpen((old) => !old), []);

  if (loading) {
    return (
      <Stack alignItems={"center"}>
        <CircularProgress sx={{ color: "#7b809a" }} />
      </Stack>
    );
  }

  return (
    <Fragment>
      <MDBox>
        <Stack gap={1} margin={"10px 0"}>
          <Box
            component={"p"}
            sx={{
              fontFamily: "Roboto",
              fontSize: "0.9rem",
              fontWeight: "400",
              lineHeight: "1.4375em",
              letterSpacing: "0.00938em",
              padding: 0,
              position: "relative",
              color: !!errors ? "#F44335" : "#7b809a",
            }}
          >
            {label}
            {required && " *"}
          </Box>
          {id && url && !hasError ? (
            <Box
              sx={{
                position: "relative",
                width: "fit-content",
                ".select-img-container": {
                  display: "none",
                },
                "&:hover .select-img-container": {
                  display: enabled ? "flex" : "none",
                },
              }}
            >
              <Box
                onError={() => setError(true)}
                component={"img"}
                sx={{
                  objectFit: "cover",
                  maxHeight: 300,
                  maxWidth: 300,
                  minWidth: 100,
                  minHeight: 100,
                }}
                src={url}
                alt=""
              />
              <Box
                className="select-img-container"
                sx={{
                  position: "absolute",
                  height: "100%",
                  width: "100%",
                  top: 0,
                  left: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backdropFilter: "blur(3px)",
                }}
              >
                <MDButton
                  sx={{
                    height: 30,
                    border: "1px solid #7b809a",
                    width: "fit-content",
                  }}
                  disabled={!enabled}
                  onClick={handleOpen}
                >
                  Alterar
                </MDButton>
              </Box>
            </Box>
          ) : (
            <MDButton
              sx={{
                height: 30,
                border: "1px solid #7b809a",
                width: "fit-content",
              }}
              onClick={handleOpen}
              disabled={!enabled}
            >
              Selecionar
            </MDButton>
          )}
        </Stack>
        {!!description && <FormHelperText>{description}</FormHelperText>}
        {!!errors && <FormHelperText error>{errors}</FormHelperText>}
      </MDBox>
      {enabled && (
        <ModalMidiaFile
          fileType="IMAGES"
          onClickMidia={onSelectImage}
          onClose={handleOpen}
          open={open}
        />
      )}
    </Fragment>
  );
};

export default withJsonFormsControlProps(GalleryMediaFileId, true);
